import { formatDate } from '@angular/common';
import { SubcategoriesList } from '../../../../../pages/admin-dashboard/admin-subcategories/admin-subcategories.model';
import { SubcategoryTableRow } from './subcategory-table-component.model';

function toSubcategoryTableRow(
  subcategory: SubcategoriesList,
  index: number,
  isArabic: boolean,
  locale: string,
): SubcategoryTableRow {
  const date = subcategory.createdOn ? formatDate(subcategory.createdOn, 'mediumDate', locale) : '—';

  return {
    id: subcategory.id,
    index,
    name: (isArabic ? subcategory.titleAr : subcategory.titleEn) || subcategory.titleEn,
    dateCreated: date,
    activationStatus: subcategory.isActive
      ? { titleEn: 'Active', titleAr: 'نشط' }
      : { titleEn: 'Inactive', titleAr: 'غير نشط' },
  };
}

export function toSubcategoryTableRows(
  subcategories: SubcategoriesList[],
  isArabic: boolean,
  locale: string,
  firstIndex = 1,
): SubcategoryTableRow[] {
  return subcategories.map((c, i) => toSubcategoryTableRow(c, firstIndex + i, isArabic, locale));
}
